import StudentStaarForm from './StudentStaarForm.container';

export default StudentStaarForm;
